import { configs } from '@constants/configs/configs';
import { SIDENAV_LINKS_TYPES } from '../constants/sideNavLinkTypes';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';

const { AGENCY_MANAGER, BROKER, BROKER_ADMIN } = ALL_USER_ROLES;
const {
    routes,
    endpoints,
    externalEndpoints,
    states : {
        CALIFORNIA,
        NEVADA,
        PENNSYLVANIA,
        NEW_JERSEY,
        MINNESOTA,
        IDAHO,
        GEORGIA,
        GETINSURED,
        VIRGINIA,
        ILLINOIS,
        NEW_MEXICO
    }
} = configs;

export const brokerNavLinksNames = {
    PENDING_EMP:  'nav_pending_emp',
    BROKER_SELF_DELEGATION_TOOL: 'nav_self_delegation_tool_broker',
    PENDING_DELEGATION_REQ: 'nav_pending_delegation_req',
    MY_PROFILE: 'nav_my_profile',
    ADD_NEW_EMP: 'nav_add_new_emp',
    START_NEW_APP: 'nav_start_new_app',
    ENROLLER_TOOLKIT: 'nav_enrller_toolkit',
    MY_DELEGATION: 'delegation_header--2',
    PENDING_INDIVIDUALS: 'nav_pending_indiv',
    ADD_NEW_INDIVIDUAL: 'nav_add_new_indiv',
    TICKET: 'nav_my_tickets'
};

export const brokerNavLinks = {
    [CALIFORNIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.BROKER_SELF_DELEGATION_TOOL,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.CA_LINKS.BROKER_SELF_DELEGATION_TOOL,
                    text: brokerNavLinksNames.BROKER_SELF_DELEGATION_TOOL,
                    visibility: userActiveRoleName => [AGENCY_MANAGER, BROKER].includes(userActiveRoleName)
                },
                {
                    name: brokerNavLinksNames.PENDING_EMP,
                    icon: 'share',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_EMP,
                    text: brokerNavLinksNames.PENDING_EMP,
                    visibility: employerFlowAllowed => employerFlowAllowed
                },
                {
                    name: brokerNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_IND,
                    text: brokerNavLinksNames.PENDING_DELEGATION_REQ,
                    visibility: individualFlowAllowed => individualFlowAllowed

                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: true

                },
                {
                    name: brokerNavLinksNames.ADD_NEW_EMP,
                    icon: 'share',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_NEW_EMP,
                    text: brokerNavLinksNames.ADD_NEW_EMP,
                    visibility: employerFlowAllowed => employerFlowAllowed
                },
                {
                    name: brokerNavLinksNames.START_NEW_APP,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.CA_LINKS.CA_START_NEW_APP,
                    text: brokerNavLinksNames.START_NEW_APP,
                    visibility: adminUser => !adminUser
                },
                {
                    name: brokerNavLinksNames.ENROLLER_TOOLKIT,
                    icon: 'wrench',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.CA_LINKS.CA_TOOLKIT,
                    text: brokerNavLinksNames.ENROLLER_TOOLKIT,
                    visibility: userActiveRoleName => [AGENCY_MANAGER, BROKER, BROKER_ADMIN].includes(userActiveRoleName),
                    blank: true
                }
            ]
        }

    ],

    [GEORGIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: designationHistoryEnabled => designationHistoryEnabled

                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ],

    [IDAHO]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: designationHistoryEnabled => designationHistoryEnabled

                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ],

    [ILLINOIS]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: designationHistoryEnabled => designationHistoryEnabled

                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ],

    [MINNESOTA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: designationHistoryEnabled => designationHistoryEnabled

                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ],

    [NEVADA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ],

    [NEW_JERSEY]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: designationHistoryEnabled => designationHistoryEnabled

                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ],

    [NEW_MEXICO]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: designationHistoryEnabled => designationHistoryEnabled

                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ],

    [PENNSYLVANIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: designationHistoryEnabled => designationHistoryEnabled

                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ],
    [GETINSURED]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: designationHistoryEnabled => designationHistoryEnabled

                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ],
    [VIRGINIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PENDING_INDIVIDUAL,
                    text: brokerNavLinksNames.PENDING_INDIVIDUALS,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_VIEW_PROFILE,
                    text: brokerNavLinksNames.MY_PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    text: brokerNavLinksNames.MY_DELEGATION,
                    visibility: designationHistoryEnabled => designationHistoryEnabled

                },
                {
                    name: brokerNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: brokerNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    text: brokerNavLinksNames.ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled
                },
            ]
        }
    ]

};

